import apis from ".";
export const getUserMeta = async (token) => {
  try {
    const result = await apis.get("/user", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserInfo = async (user, token) => {
  try {
    const result = await apis.post(
      "/user",
      {
        name: user.name,
        email: user.email,
        phone: user.phone,
        gender: user.gender,
        dob: user.dob,
        street: user.street,
        ward: user.ward,
        district: user.district,
        city: user.city,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserAddress = async (address, token) => {
  try {
    const result = await apis.post(
      "/user/address",
      {
        street: address.street,
        ward: address.ward,
        district: address.district,
        city: address.city,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserMail = async (mail, token) => {
  try {
    const result = await apis.post(
      "/user/mail",
      {
        mail: mail,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserPhone = async (phone, token) => {
  try {
    const result = await apis.post(
      "/user/phone",
      {
        phone: phone,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserAvatar = async (formData, token) => {
  try {
    const result = await apis.post("/user/avatar", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const UpdateUserPassword = async (data = {
  emailOrPhone: "",
  oldPassword: "",
  password: "",
  confirmPassword: "",
  otp: ""
}, token) => {
  try {
    if (!data) throw "Invalid args"
    const result = await apis.post("/reset-password-otp", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};